// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import constants from "@store/constants";
import clearSearch from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/ClearSearch";
import updateSearchFields from "@store/Framework/Store/Greif/Pages/ShipmentHistory/Handlers/UpdateSearchFields";
import { tableFilterProps } from "@store/Themes/common/props/table";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentShipTo: getCurrentShipToState(state),
});

const mapDispatchToProps = {
    clearSearch,
    updateSearchFields,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ShipmentHistorySearchClearButtonStyles {
    clearButton?: ButtonPresentationProps;
}

export const clearButtonStyles: ShipmentHistorySearchClearButtonStyles = {
    clearButton: tableFilterProps.clearButton,
};

const styles = clearButtonStyles;

const ShipmentHistorySearchClearButton = ({ currentShipTo, clearSearch, updateSearchFields }: Props) => {
    const [currentCustomerSequence, setCurrentCustomerSequence] = useState<string>("");

    useEffect(() => {
        if (currentShipTo.value && !currentShipTo.isLoading) {
            setCurrentCustomerSequence(currentShipTo.value.customerSequence);
        }
    }, [currentShipTo]);

    const clearSearchHandler = () => {
        clearSearch();
        updateSearchFields({ customerSequence: currentCustomerSequence });
    };

    return (
        <FormActions>
            <Button
                {...styles.clearButton}
                data-test-selector="shipmentHistory_clearFilters"
                onClick={clearSearchHandler}
            >
                {translate("Reset Filters")}
            </Button>
        </FormActions>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ShipmentHistorySearchClearButton),
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        displayName: "Clear Filters Button",
        allowedContexts: [constants.pageType.shipmentHistory],
    },
};

export default widgetModule;
